/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import Toolbar from 'loracoms/Toolbar';
import 'react-rangeslider/lib/index.css';
import Slider from 'react-rangeslider';
import styles from './styles.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
};

class SignalCoverageView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transmitPower: 17,
      structuralAttenuation: 10,
      gatewayAntenna: 3,
      endNodeAntenna: 0,
      fadeMargin: 20,
      Sensitivity: -130,
      gatewayAntennaHeight: 6,
      endNodeHeight: 1,
      distance: 0,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.signalcoverageview');
  }

  componentDidMount() {
    this.doCalculation();
  }

  handleOnChange(value, key) {
    const d = {};
    d[key] = value;
    this.setState(d);
    this.doCalculation();
  }

  doCalculation() {
    const { transmitPower,
      structuralAttenuation,
      gatewayAntenna,
      endNodeAntenna,
      fadeMargin,
      Sensitivity,
      gatewayAntennaHeight,
      endNodeHeight,
    } = this.state;
    let r = ((0.001
           * (10 ** (transmitPower / 10))
           * (10 ** (endNodeAntenna / 10))
           * (10 ** (-Math.abs(structuralAttenuation) / 10))
           * (10 ** (gatewayAntenna / 10))
           * (10 ** (fadeMargin / -10))
           * (endNodeHeight ** 2)
           * (gatewayAntennaHeight ** 2))
           / (0.001 * (10 ** (Sensitivity / 10)))) **
         0.25;
    r = Math.round((r + 0.00001) * 100) / 100;
    this.setState({
      distance: r,
    });
  }

  renderToolbar() {
    const title = (<div>{this.intlMsg.msg('title')}</div>);
    return (<Toolbar
      brandTitle={title}
    />
    );
  }

  renderSilider(value, name, min, max, unit, step) {
    return (
      <div>
        <Row>
          <Col md={12}>
            {this.intlMsg.msg(name)}
            <div className="pull-right">
              {this.state[name]}&nbsp;
              {unit}
            </div>
          </Col>
        </Row>
        <Slider
          className={styles.slider}
          min={min}
          max={max}
          value={value}
          step={step}
          format={p => p + unit}
          onChange={e => this.handleOnChange(e, name)}
          onChangeComplete={() => { this.doCalculation(); }}
        />
      </div>
    );
  }

  render() {
    const { transmitPower,
      structuralAttenuation,
      gatewayAntenna,
      endNodeAntenna,
      fadeMargin,
      Sensitivity,
      gatewayAntennaHeight,
      endNodeHeight,
      distance,
    } = this.state;
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Panel bsStyle="aisz-white" header={''}>
              {this.renderSilider(transmitPower, 'transmitPower', 0, 30, 'dBm', 1)}
              {this.renderSilider(structuralAttenuation, 'structuralAttenuation', 0, 40, 'dB', 1)}
              {this.renderSilider(gatewayAntenna, 'gatewayAntenna', 0, 10, 'dBi', 1)}
              {this.renderSilider(endNodeAntenna, 'endNodeAntenna', -3, 10, 'dBi', 1)}
              {this.renderSilider(fadeMargin, 'fadeMargin', 0, 30, 'dB', 1)}
              {this.renderSilider(Sensitivity, 'Sensitivity', -140, -120, 'dBm', 1)}
              {this.renderSilider(gatewayAntennaHeight, 'gatewayAntennaHeight', 1, 80, 'm', 0.5)}
              {this.renderSilider(endNodeHeight, 'endNodeHeight', 0, 5, 'm', 0.1)}
            </Panel>
          </Col>
          <Col md={6}>
            <Panel bsStyle="aisz-white" header={''}>
              <Row>
                <Col md={1}>
                  <h1><span className="fa fa-wifi" /></h1>
                </Col>
                <Col md={11}>
                  <h3>
                    {this.intlMsg.msg('description.heading')}&nbsp;
                  </h3>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <div className={styles.distanceText}>
                    {distance}&nbsp;m
                  </div>
                </Col>
              </Row>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

SignalCoverageView.propTypes = propTypes;

export default injectIntl(SignalCoverageView);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/SignalCoverageView/index.jsx